import { render, staticRenderFns } from "./checkPermisos.vue?vue&type=template&id=2d82b75b&"
import script from "./checkPermisos.vue?vue&type=script&lang=js&"
export * from "./checkPermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports